import { Component, h } from 'preact';
import { deviceVariance } from '@cube/blocks';
import { DIMENSION, trackingProvider } from '@cube/track';

import { configure } from '../../../../config';
import { getDeviceTemplate, getPageConfig } from '../../../../lib/device';
import { COMMON_CONFIGS } from '../../../../lib/page';
import { trackPageLoad } from '../../../../lib/tracking';
import { Desktop } from './device/desktop';
import { Phone } from './device/phone';
import { createGsuIframeInstance } from '../shared';

@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.onlineClass'
})
@trackingProvider({
	[DIMENSION.componentpath]: 'OnlineClassPlayerPage'
})
@deviceVariance()
export default class OnlineClassPlayer extends Component {

	gsuIframeInstance = null;

	componentWillMount() {
		const device = this.props.device;
		const pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({ pageConfig, Device: getDeviceTemplate({ device, Desktop, Tablet: Phone, Phone }) });
	}

	componentDidMount() {
		trackPageLoad(this.context);
		this.gsuIframeInstance = createGsuIframeInstance(this.props, this.state);
	}

	componentWillUnmount() {
		if (this.gsuIframeInstance !== null) {
			this.gsuIframeInstance.cleanUp();
			this.gsuIframeInstance = null;
		}
	}

	render({ getSetUpTargetPage, device, ...props }, { Device, pageConfig }) {
		return (
			<Device
				getSetUpTargetPage={getSetUpTargetPage}
				pageConfig={pageConfig}
				{...props}
			/>
		);
	}

}
